//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum Locales {
  'DA_DK' = 'da-dk',
  'DE_DE' = 'de-de',
  'EN_CA' = 'en-ca',
  'EN_EU' = 'en-eu',
  'EN_GB' = 'en-gb',
  'EN_US' = 'en-us',
  'ES_ES' = 'es-es',
  'ES_MX' = 'es-mx',
  'ES_US' = 'es-us',
  'FI_FI' = 'fi-fi',
  'FR_CA' = 'fr-ca',
  'FR_FR' = 'fr-fr',
  'ID_ID' = 'id-id',
  'IT_IT' = 'it-it',
  'JA_JP' = 'ja-jp',
  'KO_KR' = 'ko-kr',
  'NL_NL' = 'nl-nl',
  'PL_PL' = 'pl-pl',
  'PT_BR' = 'pt-br',
  'RU_RU' = 'ru-ru',
  'SV_SE' = 'sv-se',
  'ZH_CN' = 'zh-cn',
}
